import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'containers/misc'
import { Title, Form, Span } from 'components/layout'
import { Button } from 'components/misc'
import { form } from 'helpers/decorators'
import { injectIntl, FormattedMessage } from 'react-intl'

@form({
  form: 'update-translations-results-modal',
  disableHook: true
})
@injectIntl
class UpdateTranslationsResultsModal extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    modalId: PropTypes.string,
    modal: PropTypes.func,
    successfulCount: PropTypes.number,
    unsuccessfulCount: PropTypes.number,
    errorResults: PropTypes.array,
    onConfirmed: PropTypes.func.isRequired
  }

  render() {
    const {
      modalId,
      modal,
      successfulCount,
      unsuccessfulCount,
      errorResults,
      onConfirmed,
      handleSubmit
    } = this.props
    const hasSuccessful = successfulCount ? true : ''
    const hasUnsuccessful = unsuccessfulCount ? true : ''
    const hasErrors = errorResults && errorResults.length ? true : ''

    return (
      <Modal id={modalId} modal={modal} customActions>
        <Title h2 intlKey="label.update_translations_results">
         Update translations results
        </Title>
        <Form
          className="form"
          onSubmit={handleSubmit(onConfirmed)}
        >
          <div style={{ marginBottom: '15px' }}>
            {hasSuccessful &&
              <div className="row">
                <div className="col-xs-12">
                  <FormattedMessage
                    tagName="p"
                    id="label.update_translations_successful"
                    defaultMessage="{count} items successfully modified."
                    values={{
                      count: successfulCount
                    }}
                  />
                </div>
              </div>
            }
            {hasUnsuccessful &&
            <div className="row">
              <div className="col-xs-12">
                <FormattedMessage
                  tagName="p"
                  id="label.update_translations_unsuccessful"
                  defaultMessage="{count} items failed:"
                  values={{
                    count: unsuccessfulCount
                  }}
                />
              </div>
            </div>
            }
            {hasErrors &&
            <div className="row">
              <div className="col-xs-12">
                {errorResults.map(result => (
                  <FormattedMessage
                    id="label.update_translations_error_item"
                    defaultMessage="Update translation failed for: {language}, code: {localeCode}, project: {projectCode} because"
                    values={result}
                  >
                    {txt => (
                      <div style={{ marginBottom: '10px' }}>
                        <div style={{ marginLeft: '20px' }}>
                          <Span>{txt}</Span>
                        </div>
                        <div style={{ marginLeft: '40px' }}>
                          <Span error>{result.errorMessage}</Span>
                        </div>
                      </div>
                    )}
                  </FormattedMessage>
                ))}
              </div>
            </div>
            }
          </div>
          <div className="row">
            <div className="col-xs-12 text--center">
              <Button
                intlKey="button.dismiss"
                secondary
                type="submit"
                style={{ marginRight: 10 }}
              >
                Dismiss
              </Button>
            </div>
          </div>
        </Form>
      </Modal>
    )
  }
}

export default UpdateTranslationsResultsModal
